module.exports = __webpack_public_path__ + "img/al.ala6a6e8a.svg";